import bButtonToolbar from './button-toolbar';
import { registerComponents, vueUse } from '../../utils/plugins';

var components = {
  bButtonToolbar: bButtonToolbar,
  bBtnToolbar: bButtonToolbar
};

var VuePlugin = {
  install: function install(Vue) {
    registerComponents(Vue, components);
  }
};

vueUse(VuePlugin);

export default VuePlugin;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/button-toolbar/index.js
// module id = 634
// module chunks = 0